import {httpGetHolidays, HttpGetHolidaysResponse} from '@/features/projects/http/projects.http'
import {QUERY_KEYS} from '@/queryClient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'

interface UseGetHolidaysOptions {
    urlParams: {
        year: number
    }
    options?: Omit<UseQueryOptions<HttpGetHolidaysResponse, Error>, 'queryKey' | 'queryFn'>
}

export const useGetHolidays = ({urlParams, options}: UseGetHolidaysOptions) =>
    useQuery({
        queryKey: [QUERY_KEYS.HOLIDAYS, urlParams.year],
        queryFn: () => httpGetHolidays({urlParams}),
        ...options
    })
